import { useJobsStore } from "@/runtime/jobsStore";
import type { JobSnapshot } from "@/types";

export function useJobsPolling(): { jobs: JobSnapshot[]; loading: boolean } {
  const jobs = useJobsStore((s) => s.jobs);
  const loading = useJobsStore((s) => s.loading);
  return { jobs, loading };
}
